export const CS = {
  // nav
  navLogo: "nav-logo",
  navPricing: "nav-pricing-link",
  navFeatures: "nav-features-link",
  navLogin: "nav-login-btn",
  navTrial: "nav-trial-btn",
  navDashboard: "nav-dashboard-btn",
  // hero
  heroTrial: "hero-trial-btn",
  heroDemo: "hero-demo-btn",
  heroCounter: "hero-blocked-counter",
  // calculator
  calcSpendSlider: "calc-spend-slider",
  calcPlatform: "calc-platform-select",
  calcSavings: "calc-savings-output",
  // pricing
  pricingToggle: "pricing-billing-toggle",
  planCard: (id) => `plan-card-${id}`,
  planCta: (id) => `plan-cta-${id}`,
  // auth
  authEmail: "auth-email-input",
  authPassword: "auth-password-input",
  authName: "auth-name-input",
  authSubmit: "auth-submit-btn",
  authError: "auth-error",
  authSwitch: "auth-switch-link",
  // dashboard
  dashOverviewTab: "dash-tab-overview",
  dashCampaignsTab: "dash-tab-campaigns",
  dashFraudTab: "dash-tab-fraud",
  dashBillingTab: "dash-tab-billing",
  dashLogout: "dash-logout-btn",
  campaignToggle: (id) => `campaign-toggle-${id}`,
  fraudRefresh: "fraud-refresh-btn",
  // billing & reports
  billingPlanCard: "billing-plan-card",
  billingManageBtn: "billing-manage-btn",
  reportWeeklyToggle: "report-weekly-toggle",
  reportSendNowBtn: "report-send-now-btn",
  reportLastSent: "report-last-sent",
  // oauth consent
  oauthConsentCard: "oauth-consent-card",
  oauthConsentAllow: "oauth-consent-allow-btn",
  oauthConsentCancel: "oauth-consent-cancel-btn",
  // tracking
  dashTrackingTab: "dash-tab-tracking",
  trackingSnippet: "tracking-snippet-code",
  trackingCopyBtn: "tracking-copy-btn",
  trackingSiteKey: "tracking-site-key",
  trackingEventsCount: "tracking-events-count",
  trackingDataSource: "tracking-data-source",
  trackingRedirectToggle: "tracking-redirect-toggle",
  trackingRedirectUrl: "tracking-redirect-url-input",
  trackingSaveBtn: "tracking-save-btn",
  // pdf
  billingPdfBtn: "billing-pdf-btn",
  // overview
  overviewDataSource: "overview-data-source",
  fraudDataSource: "fraud-data-source",
  // password reset
  authForgotLink: "auth-forgot-link",
  forgotEmail: "forgot-email-input",
  forgotSubmit: "forgot-submit-btn",
  forgotSuccess: "forgot-success-msg",
  resetPasswordInput: "reset-password-input",
  resetSubmit: "reset-submit-btn",
  resetError: "reset-error-msg",
  // plan gating
  campaignLocked: (id) => `campaign-locked-${id}`,
  campaignUpgrade: (id) => `campaign-upgrade-${id}`,
  // custom rules
  ruleTypeSelect: "rule-type-select",
  ruleValueSelect: "rule-value-select",
  ruleValueInput: "rule-value-input",
  ruleAddBtn: "rule-add-btn",
  ruleRow: (id) => `rule-row-${id}`,
  ruleDelete: (id) => `rule-delete-${id}`,
};
